import BaseAdapter from './base-adapter'
import { maskEmail, maskPhoneNumber } from '@/utils/logger'

import { rudderstackLoader } from '@/plugins/tracking/helpers/rudderstack-loader'

export default class RudderStackAdapter extends BaseAdapter {
  constructor(locator) {
    super(locator)

    this.writeKey = locator.config.rudderStackWriteKey
    this.dataPlaneUrl = locator.config.rudderStackDataPlaneUrl

    this.isInitialized = false
  }

  init() {
    return new Promise((resolve) => {
      if (this.isInitialized) {
        return resolve()
      }

      if (!this.writeKey || !this.dataPlaneUrl) {
        console.warn(
          '[RudderStack] Not initialized yet. Write key or data plane URL is not set'
        )

        return resolve()
      }

      rudderstackLoader(this.writeKey, this.dataPlaneUrl, {
        logLevel: 'ERROR',
        beaconQueueOptions: {
          maxItems: 5,
          flushInterval: 500,
        },
        onLoaded: () => {
          console.warn('RudderStack JavaScript SDK loaded successfully')
        },
      })

      this.rudderAnalytics = window.rudderanalytics || {}

      this.rudderAnalytics.ready(() => {
        this.isInitialized = true
        resolve()
      })
    })
  }

  maskSensitiveData(payload) {
    if (!payload || typeof payload !== 'object') {
      return payload
    }
    const maskedPayload = { ...payload }

    if (maskedPayload.email) {
      maskedPayload.email = maskEmail(maskedPayload.email)
    }
    if (maskedPayload.phone_number) {
      maskedPayload.phone_number = maskPhoneNumber(maskedPayload.phone_number)
    }
    return maskedPayload
  }

  trackEvent(eventName, payload) {
    if (!this.isInitialized) {
      console.warn(
        '[RudderStack] Not initialized yet. Event not sent:',
        eventName
      )
      return
    }

    const maskedPayload = this.maskSensitiveData(payload)
    this.rudderAnalytics.track(eventName, maskedPayload)
  }

  identify(userId, traits = {}) {
    if (!this.isInitialized) {
      console.warn(
        '[RudderStack] Not initialized yet. Identify not sent:',
        userId
      )
      return
    }

    const maskedTraits = this.maskSensitiveData(traits)
    this.rudderAnalytics.identify(userId, maskedTraits)
  }

  reset() {
    if (this.isInitialized) {
      this.rudderAnalytics.reset()
    }
  }
}
